import GoogleDrive from "components/widgets/WidgetBuilder/GoogleDrive";
import GooglePhotos from "components/widgets/WidgetBuilder/GooglePhotos";
import TikTok from "components/widgets/WidgetBuilder/TikTok/TikTok";
import WidgetTikTok from "components/widgets/WidgetBuilder/TikTok/WidgetTikTok";
import WidgetYouTube from "components/widgets/WidgetBuilder/YouTube/WidgetYouTube";
import YouTube from "components/widgets/WidgetBuilder/YouTube/YouTube";
import { UPLOADER_TYPE } from "constants/common";
import DynamicWidgetContext from "contexts/DynamicWidget";
import { WidgetFieldTypes } from "models/DynamicWidget";
import { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import utils from "services/utils";
import { showErrorMsg } from "services/widgetBuilder";
import { StyledText, StyledWrapper } from "styled-components/Common/CommonStyled";
import { StyledSocialButtonWrapper } from "styled-components/DynamicWidget/DynamicWidgetStyled";

type SocialUploadProps = {
	uploadFieldDetails: WidgetFieldTypes;
};

const SocialUpload = (props: SocialUploadProps) => {
	const { uploadFieldDetails } = props;
	const {
		widgetDetails,
		setGoogleRequestData,
		setActiveUploadType,
		activeUploadType,
		setTikTokUser,
		modalType,
		setModalType,
		setSelectedSocialVideoList,
	} = useContext(DynamicWidgetContext);
	const {
		enableSharing = false,
		enableSharingYouTube = false,
		enableSharingGooglePhotos = false,
		enableSharingGoogleDrive = false,
	} = uploadFieldDetails || {};
	const { t } = useTranslation();
	const { uploadSourceType } = useSelector((state: any) => state.widgets);

	const [socialVideoList, setSocialVideoList] = useState<any>();
	const [socialRequestPayload, setSocialRequestPayload] = useState<any>();

	const socialButtonList = [
		{
			icon: (
				<GoogleDrive
					widgetInfo={widgetDetails}
					handleErrorMsg={showErrorMsg}
					setGoogleAppData={setGoogleRequestData}
				/>
			),
			isShown: enableSharingGoogleDrive,
			type: UPLOADER_TYPE.GOOGLE_DRIVE,
		},
		{
			icon: (
				<GooglePhotos
					widgetInfo={widgetDetails}
					handleErrorMsg={showErrorMsg}
					setGoogleAppData={setGoogleRequestData}
					activeUploaderType={activeUploadType}
				/>
			),
			isShown: enableSharingGooglePhotos,
			type: UPLOADER_TYPE.GOOGLE_PHOTOS,
		},
		{
			icon: <YouTube setModalType={setModalType} modalType={modalType} />,
			isShown: enableSharingYouTube,
			type: UPLOADER_TYPE.YOUTUBE,
		},
		{
			icon: <TikTok setModalType={setModalType} setVideoList={setSocialVideoList} />,
			isShown: enableSharing,
			type: UPLOADER_TYPE.TIKTOK,
		},
	];

	const socialSource = useMemo(() => {
		return {
			isTikTok: uploadSourceType === UPLOADER_TYPE.TIKTOK,
			isInstagram: uploadSourceType === UPLOADER_TYPE.INSTAGRAM,
		};
	}, [uploadSourceType]);

	return (
		<StyledWrapper width="100%" margin="24px auto 0 auto">
			<StyledText align="center">{t("widget_builder.choose_another_source")}</StyledText>

			<StyledWrapper margin="8px 0" display="flex" gap="16px" justifyContent="center">
				{socialButtonList.map((item) => {
					return (
						item.isShown && (
							<StyledSocialButtonWrapper
								key={item.type}
								onClick={() => {
									setActiveUploadType(item.type);
								}}>
								{item.icon}
							</StyledSocialButtonWrapper>
						)
					);
				})}
			</StyledWrapper>

			{enableSharing && (
				<WidgetTikTok
					isMobile={utils.isMobileWidth()}
					videoList={socialVideoList as any}
					setVideoList={setSocialVideoList}
					uploadInfo={socialRequestPayload || {}}
					setUploadInfo={setSocialRequestPayload}
					widgetInfo={widgetDetails}
					modalType={modalType}
					setModalType={setModalType}
					socialSource={socialSource}
					setTikTokUser={setTikTokUser}
					setSelectedVideoList={setSelectedSocialVideoList}
					tikTokEnabled={enableSharing}
					isNewLayout={true}
				/>
			)}

			{enableSharingYouTube && (
				<WidgetYouTube
					widgetInfo={widgetDetails}
					isMobile={utils.isMobileWidth()}
					setSelectedVideoList={setSelectedSocialVideoList}
					setModalType={setModalType}
					modalType={modalType}
					isNewLayout={true}
				/>
			)}
		</StyledWrapper>
	);
};

export default SocialUpload;
